//  213-app.js
// File: plc-frontend/src/App.js (Updated with Alarm and Compressor Status)
import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, TimeScale, Title, Tooltip, Legend } from 'chart.js';
import 'chartjs-adapter-date-fns';
import zoomPlugin from 'chartjs-plugin-zoom';
import { jwtDecode } from 'jwt-decode';
import HistoryModal from './HistoryModal';
import AlarmPage from './AlarmPage';
import AccelLogo from './accel_logo.png';
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, TimeScale, Title, Tooltip, Legend, zoomPlugin);



// ---  VFD Page Component ---
const VFDPage = ({ setCurrentPage, vfdUrlWithToken }) => {
    return (
        <div className="vfd-page-container">
            <div className="vfd-header">
                <h2>VFD Controls Interface</h2>
                <button onClick={() => setCurrentPage('dashboard')} className="home-button">Back to Dashboard</button>
            </div>
            <iframe
                src={vfdUrlWithToken}
                title="VFD Controls"
                className="vfd-iframe"
            />
        </div>
    );
};



//  reusable component for collapsible sections ---
const CollapsibleSection = ({ title, children }) => {
    const [isOpen, setIsOpen] = useState(false); // Default to closed

    return (
        <div className="section-container">
            <button className="collapsible-button" onClick={() => setIsOpen(!isOpen)}>
                <h2>{title}</h2>
                <span className="collapsible-icon">{isOpen ? '▼' : '▶'}</span>
            </button>
            {isOpen && (
                <div className="collapsible-content">
                    {children}
                </div>
            )}
        </div>
    );
};


const createInitialChartState = (label, borderColor, stepped = false) => ({
    datasets: [{
        label,
        data: [],
        borderColor,
        backgroundColor: borderColor + '80',
        tension: 0.2,
        pointRadius: 1,
        stepped: stepped,
        spanGaps: true, 
    }]
});

function App() {
    const [plcData, setPlcData] = useState({ coils: {}, holdingRegisters: {} });
    const [error, setError] = useState(null);
    const [historyItem, setHistoryItem] = useState(null);
    const [registerInputs, setRegisterInputs] = useState({});
    const [userRoles, setUserRoles] = useState([]);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [currentPage, setCurrentPage] = useState('dashboard');
    const [alarmConfig, setAlarmConfig] = useState([]);
    const [alarmStatusMessage, setAlarmStatusMessage] = useState('Checking for alarms...');
    const [alarmStatusType, setAlarmStatusType] = useState('ok'); // <-- 1. ADDED THIS STATE
    const [compressorStatus, setCompressorStatus] = useState('Checking...');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [loginError, setLoginError] = useState('');

    // --- NEW: State for the write-confirmation banner ---
    const [banner, setBanner] = useState({ show: false, message: '', type: 'success' });
    const bannerTimeoutRef = useRef(null); // To manage hiding the banner

    const API_GATEWAY_URL = 'https://api.thomasevolutioncontrols.com';

    const HOMEPAGE_URL = 'https://home.thomasevolutioncontrols.com'; 
    //const HOMEPAGE_URL = 'http://100.95.91.101:3003';//TAILSCALE
    //const HOMEPAGE_URL = 'http://173.27.240.7:3003';//OPENVPN

    //const MODBUS_BACKEND_URL ='https://plc-216.thomasevolutioncontrols.com';
    //const MODBUS_BACKEND_URL = 'http://100.95.91.101:3216';//TAILSCALE
    //const MODBUS_BACKEND_URL = 'http://173.27.240.7:3216';//OPENVPN
    //const VFD_URL = 'http://100.95.91.101:3166';







    const VFD_URL = 'https://vfd-133.thomasevolutioncontrols.com';

    const DASHBOARD_ID = '213'; // This tells the gateway which backend to talk to







   
    const POLLING_INTERVAL = 4000;
    const MAX_DATA_POINTS = (6 * 60 * 60 * 1000) / POLLING_INTERVAL;

    // --- Point Configurations (diConfig, doConfig, etc.) remain the same ---
    const diConfig = [
        { name: 'DI0',  label: 'Compressor Motor Run Confirmation',      address: 24576,  isReadOnly: true, type: 'coil' },
        { name: 'DI1',  label: 'Oil Motor Run Confirmation-Motor ',        address: 24577,  isReadOnly: true, type: 'coil' },
        { name: 'DI2',  label: 'VFD Fault -VFD',      address: 24578,  isReadOnly: true, type: 'coil' },
        { name: 'DI3',  label: 'Low Suction Pressure Switch',    address: 24579,  isReadOnly: true, type: 'coil' },
        { name: 'DI4',  label: 'High Suction Pressure Switch', address: 24580,  isReadOnly: true, type: 'coil' },
        { name: 'DI5',  label: 'I5-Remote "ROC" Shutdown',         address: 24581,  isReadOnly: true, type: 'coil' },
        { name: 'DI6',  label: 'I6-The H2S is High',         address: 24582,  isReadOnly: true, type: 'coil' },
        { name: 'DI7',  label: 'I7-LOW Compressor Oil Pressure',           address: 24583,  isReadOnly: true, type: 'coil' },
        { name: 'DI8',  label: 'I8-Low Oil Level',         address: 24584,  isReadOnly: true, type: 'coil' },
        { name: 'DI9',  label: 'I9-High Oil Temp',           address: 24585,  isReadOnly: true, type: 'coil' },
        { name: 'DI10', label: 'I10-High Discharge Temp(CUSTOMER)',           address: 24586, isReadOnly: true, type: 'coil' },
        { name: 'DI11', label: 'I11- High Vibration',         address: 24587, isReadOnly: true, type: 'coil' },
        { name: 'DI12', label: 'I12-Separator High Level',         address: 24588, isReadOnly: true, type: 'coil' },
        { name: 'DI13', label: 'I13-Separator Dump Valve Open',      address: 24589, isReadOnly: true, type: 'coil' },
        { name: 'DI14', label: 'I14-Separator Dump Valve Close',           address: 24590, isReadOnly: true, type: 'coil' },
        { name: 'DI15', label: 'I15-Low Discharge Pressure', address: 24591, isReadOnly: true, type: 'coil' },
        { name: 'DI16', label: 'I16-High Discharge Pressure', address: 24592, isReadOnly: true, type: 'coil' },
        { name: 'DI17', label: 'I17-ON/OFF SWITCH', address: 24593, isReadOnly: true, type: 'coil' },
    ];
    const doConfig = [

        { name: 'DO0',  label: 'watchdog timer',      address: 16384,  isReadOnly: true, type: 'coil' },
        { name: 'DO1',  label: 'Oil Cooler Start 24 VDC',      address: 16385,  isReadOnly: true, type: 'coil' },
        { name: 'DO2',  label: 'Compressor Start',       address: 16386,  isReadOnly: true, type: 'coil' },
        { name: 'DO3',  label: 'Oil Cooling Motor Start', address: 16387,  isReadOnly: true, type: 'coil' },
        { name: 'DO4',  label: 'Open Dump Valve', address: 16388,  isReadOnly: true, type: 'coil' },
        { name: 'DO5',  label: 'Oil Pump Start 24 VDC', address: 16389,  isReadOnly: true, type: 'coil' },
        { name: 'DO6',  label: 'Run Warning Indication', address: 16390,  isReadOnly: true, type: 'coil' },
        { name: 'DO7',  label: 'Alarm Output', address: 16391,  isReadOnly: true, type: 'coil' },
        { name: 'DO8',  label: 'OPEN BYPASS VALVE 2', address: 16392,  isReadOnly: true, type: 'coil' },
        { name: 'DO9',  label: 'OPEN DUMP VALVE 2', address: 16393,  isReadOnly: true, type: 'coil' },
        { name: 'DO10', label: 'Open Inlet Control Valve(VFD RESET DO10)', address: 16394, isReadOnly: true, type: 'coil' },
        { name: 'DO11', label: 'Close Inlet Control Valve', address: 16395, isReadOnly: true, type: 'coil' },
        { name: 'DO12', label: 'Low Suction Pressure indication', address: 16396, isReadOnly: true, type: 'coil' },
        { name: 'DO13', label: 'High Discharge Pressure Indication', address: 16397, isReadOnly: true, type: 'coil' },
        { name: 'DO14', label: 'Low Oil Pressure Indication', address: 16398, isReadOnly: true, type: 'coil' },
        { name: 'DO15', label: 'High Liquid Level Indication', address: 16399, isReadOnly: true, type: 'coil' },
        { name: 'DO16', label: 'High Temperature Indication', address: 16400, isReadOnly: true, type: 'coil' },

        ];
    // 1. configuration array for the control coils
    const unitControlsConfig = [
        //{ name: 'MB75',  label: 'ALARM RESET',  address: 75, isReadOnly: false, type: 'coil' },
        //{ name: 'MB136', label: 'VFD ALARM RESET(DO10)',  address: 136, isReadOnly: false, type: 'coil' },
        { 
          name: 'MB189', 
            label: 'REMOTE RESET BUTTON             (Button is fast, may not see it actuate. Wait for alarm reset delay before proceding.)',  
            address: 189, 
            isReadOnly: false, 
            type: 'coil',
            onLabel: 'RESETTING ALARMS', // Custom text for ON (value = 1)
            offLabel: 'NOT PRESSED'  // Custom text for OFF (value = 0)
        },

        { 
          name: 'MB190', 
            label: 'REMOTE START BUTTON              (Only use if alarm fails to start unit after reset.)',  
            address: 190, 
            isReadOnly: false, 
            type: 'coil',
            onLabel: 'STARTING UNIT', // Custom text for ON (value = 1)
            offLabel: 'NOT PRESSED'  // Custom text for OFF (value = 0)
        },
        // --- THIS IS THE CHANGE ---
        { 
            name: 'MB191', 
            label: 'ON/OFF SWITCH-INTERNAL!',  
            address: 191, 
            isReadOnly: false, 
            type: 'coil',
            onLabel: 'REMOTE SWITCH OFF', // Custom text for ON (value = 1)
            offLabel: 'REMOTE SWITCH ON',  // Custom text for OFF (value = 0)
            onClass: 'coil-off',    // Use 'coil-off' (red) style when ON
            offClass: 'coil-on'     // Use 'coil-on' (green) style when OFF
        }
        // --- END OF CHANGE ---
        ];
    const aiConfig = useMemo(() => ([
        { name: 'AI_3',  label: 'Discharge Temp (F)',   address: 3,  isReadOnly: true, type: 'register' },
        { name: 'AI_12', label: 'Inlet Valve Ref',     address: 12, isReadOnly: true, type: 'register' },
        { name: 'AI_13', label: 'VFD Speed Ref',       address: 13, isReadOnly: true, type: 'register' },
        { name: 'AI_16', label: 'Compressor Status',   address: 16, isReadOnly: true, type: 'register' },
        { name: 'AI_74', label: 'Suction Pressure',     address: 74, isReadOnly: true, type: 'register' },
        { name: 'AI_76', label: 'Discharge Pressure',   address: 76, isReadOnly: true, type: 'register' },
        { name: 'AI_78', label: 'Oil Pressure',         address: 78, isReadOnly: true, type: 'register' },
        { name: 'AI_80', label: 'Compressor RPM',       address: 80, isReadOnly: true, type: 'register' },
        { name: 'AI_151',label: 'Alarm Status Msg',     address: 151,isReadOnly: true, type: 'register' },
    ]), []);
    const aoConfig = [
        { name: 'AO_20', label: 'Suction Pressure Low Range',   address: 20, isReadOnly: false, type: 'register' },
        { name: 'AO_21', label: 'Suction Pressure High Range',  address: 21, isReadOnly: false, type: 'register' },
        { name: 'AO_23', label: 'Discharge Pressure Low Range', address: 23, isReadOnly: false, type: 'register' },
        { name: 'AO_24', label: 'Discharge Pressure High Range',address: 24, isReadOnly: false, type: 'register' },
        { name: 'AO_26', label: 'Oil Pressure Low Range',       address: 26, isReadOnly: false, type: 'register' },
        { name: 'AO_27', label: 'Oil Pressure High Range',      address: 27, isReadOnly: false, type: 'register' },
        { name: 'AO_32', label: 'Compressor Speed Low Range',   address: 32, isReadOnly: false, type: 'register' },
        { name: 'AO_33', label: 'Compressor Speed High Range',  address: 33, isReadOnly: false, type: 'register' },
        { name: 'AO_96', label: 'Bypass Valve Op Method',       address: 96, isReadOnly: false, type: 'register' },
        { name: 'AO_97', label: 'Bypass Valve Open Pressure',   address: 97, isReadOnly: false, type: 'register' },
        { name: 'AO_98', label: 'Bypass Valve Close Pressure',  address: 98, isReadOnly: false, type: 'register' },
        { name: 'AO_99', label: 'Inlet Valve Op Method',        address: 99, isReadOnly: false, type: 'register' },
        { name: 'AO_100', label: 'Low Suction Alarm',           address: 100, isReadOnly: false, type: 'register' },
        { name: 'AO_101', label: 'High Suction Alarm',          address: 101, isReadOnly: false, type: 'register' },
        { name: 'AO_102', label: 'Low Discharge Alarm',         address: 102, isReadOnly: false, type: 'register' },
        { name: 'AO_103', label: 'High Discharge Alarm',        address: 103, isReadOnly: false, type: 'register' },
        { name: 'AO_104', label: 'Low Oil PSI Alarm',           address: 104, isReadOnly: false, type: 'register' },
        { name: 'AO_105', label: 'High Discharge Temp Alarm',   address: 105, isReadOnly: false, type: 'register' },
        { name: 'AO_107', label: 'Low Suction Stop',            address: 107, isReadOnly: false, type: 'register' },
        { name: 'AO_108', label: 'High Suction Start',          address: 108, isReadOnly: false, type: 'register' },
        { name: 'AO_109', label: 'Low Discharge Start',         address: 109, isReadOnly: false, type: 'register' },
        { name: 'AO_110', label: 'High Discharge Stop',         address: 110, isReadOnly: false, type: 'register' },
        { name: 'AO_121', label: 'VFD Suction Hold',            address: 121, isReadOnly: false, type: 'register' },
        { name: 'AO_122', label: 'VFD Discharge Hold',          address: 122, isReadOnly: false, type: 'register' },
        { name: 'AO_146', label: 'Inlet Valve Open SP',         address: 146, isReadOnly: false, type: 'register' },
        { name: 'AO_147', label: 'Inlet Valve Close SP',        address: 147, isReadOnly: false, type: 'register' },
        { name: 'AO_148', label: 'VFD Fast Speed Set',          address: 148, isReadOnly: false, type: 'register' },
        { name: 'AO_149', label: 'VFD Slow Speed Set',          address: 149, isReadOnly: false, type: 'register' },
        { name: 'AO_150', label: 'Inlet Pos Force Slow',        address: 150, isReadOnly: false, type: 'register' },
        { name: 'AO_169', label: 'Inlet Pos Force Fast',        address: 169, isReadOnly: false, type: 'register' },
    ];

    const chartColors = useMemo(() => [
        'rgb(54, 162, 235)', 'rgb(75, 192, 192)', 'rgb(255, 99, 132)',
        'rgb(255, 206, 86)', 'rgb(153, 102, 255)', 'rgb(255, 159, 64)'
    ], []);

    const [charts, setCharts] = useState(() => {
        const defaultSelections = aiConfig.slice(0, 6);
        return defaultSelections.map((selection, index) => ({
            selection: selection,
            data: createInitialChartState(selection.label, chartColors[index], selection.type === 'coil')
        }));
    });

    const chartSelections = useMemo(() => charts.map(chart => chart.selection), [charts]);

    const getAuthHeaders = useCallback(() => {
        const token = localStorage.getItem('jwt_token');
        if (token) { return { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }; }
        return null;
    }, []);

    const canWrite = () => userRoles.includes('admin');

    const loadChartSettings = useCallback(async () => {
        const headers = getAuthHeaders();
        if (!headers) return null;
        try {
            //const response = await fetch(`${MODBUS_BACKEND_URL}/api/settings`, { headers });
            const response = await fetch(`${API_GATEWAY_URL}/api/settings/${DASHBOARD_ID}`, { headers });
            if (response.status === 404) return null;
            if (!response.ok) throw new Error(`Failed to load settings: ${response.statusText}`);
            const settings = await response.json();
            return (Array.isArray(settings) && settings.length === 6) ? settings : null;
        } catch (err) {
            console.error("Error loading chart settings:", err);
            setError("Could not load user settings.");
            return null;
        }
    }, [getAuthHeaders]);

    const saveChartSettings = useCallback(async (selectionsToSave) => {
        const headers = getAuthHeaders();
        if (!headers) return;
        try {
            await fetch(`${API_GATEWAY_URL}/api/settings/${DASHBOARD_ID}`, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(selectionsToSave),
            });
        } catch (err) {
            console.error("Error saving chart settings:", err);
            setError("Could not save user settings.");
        }
    }, [getAuthHeaders]);

    const saveTimeoutRef = useRef(null);

    useEffect(() => {
        if (isInitialLoad) return;
        if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current);

        saveTimeoutRef.current = setTimeout(() => {
            saveChartSettings(chartSelections);
        }, 2000);
        


        return () => {
            if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current);
        };
    }, [chartSelections, saveChartSettings, isInitialLoad]);


    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const token = params.get('token');
        if (token) {
            localStorage.setItem('jwt_token', token);
            try {
                const decodedToken = jwtDecode(token);
                setUserRoles(decodedToken.roles || []);
                setIsLoggedIn(true);
            } catch (e) {
                console.error("Invalid token:", e);
                setUserRoles([]);
            }
            window.history.replaceState({}, document.title, window.location.pathname);
        } else {
            const localToken = localStorage.getItem('jwt_token');
            if (localToken) {
                try {
                    const decodedToken = jwtDecode(localToken);
                    setUserRoles(decodedToken.roles || []);
                    setIsLoggedIn(true); // Also set logged in state here
                } catch (e) {
                    console.error("Invalid token:", e);
                    setUserRoles([]);
                }
            }
        }
    }, []);
    const fetchInitialChartData = useCallback(async (selection) => {
        const headers = getAuthHeaders();
        if (!headers) return [];
        const endTime = new Date();
        const startTime = new Date(endTime.getTime() - (6 * 60 * 60 * 1000));
        try {
            const response = await fetch(
                `${API_GATEWAY_URL}/api/history/${DASHBOARD_ID}?type=${selection.type}&address=${selection.address}&start=${startTime.toISOString()}&end=${endTime.toISOString()}`,
                { headers }
            );
            if (!response.ok) return [];
            const data = await response.json();
            return data.map(d => ({ x: new Date(d.time), y: d.value })) || [];
        } catch (err) {
            console.error(`Error fetching initial chart data for ${selection.label}`, err);
            return [];
        }
    }, [getAuthHeaders]);

     const fetchData = useCallback(async () => {
        const headers = getAuthHeaders();
        if (!headers) {
            // This case should be handled by the login check, but as a fallback:
            setError('Authentication token not found.');
            return;
        }

        try {
            if (alarmConfig.length === 0) {
                const configResponse = await fetch(`${API_GATEWAY_URL}/api/alarms/config/${DASHBOARD_ID}`, { headers });
                if (configResponse.ok) {
                    const config = await configResponse.json();
                    setAlarmConfig(config);
                } else {
                    console.error("Failed to fetch alarm config");
                }
            }

           const response = await fetch(`${API_GATEWAY_URL}/api/scada-data/${DASHBOARD_ID}`, { headers });
            
            // This is the critical fix for the redirect loop ---
            if (response.status === 401 || response.status === 403) {
                console.error("Authentication failed. Logging out.");
                handleLogout(); // Log out cleanly instead of redirecting
                return; 
            }
            if (!response.ok) throw new Error(`Network error: ${response.statusText}`);
            
            const data = await response.json();
            setPlcData(data);
            setError(null);



            // --- Logic to set Alarm Status Message ---
            if (data.holdingRegisters && alarmConfig.length > 0) {
                const alarmCode = data.holdingRegisters[151];
                if (alarmCode && alarmCode > 0) {
                    const alarm = alarmConfig.find(a => a.type === 'stateRegister' && a.address === 151 && a.triggerValue === alarmCode);
                   // --- 2. THIS IS THE NEW LOGIC ---
                    if (alarmCode === 23) {
                        // Special case for "Compressor is running"
                        setAlarmStatusMessage(alarm ? `✅ STATUS: ${alarm.name} ✅` : '✅ STATUS: Compressor is running ✅');
                        setAlarmStatusType('ok'); // Set to green
                    } else {
                        // All other alarms
                        setAlarmStatusMessage(alarm ? `🚨 ALARM: ${alarm.name} 🚨` : `🚨 Unrecognized Alarm Code: ${alarmCode} 🚨`);
                        setAlarmStatusType('alarm'); // Set to red
                    }
                    // --- END NEW LOGIC ---

                } else {
                    setAlarmStatusMessage('✅ System OK: No Active Alarms.');
                    setAlarmStatusType('ok'); // Set to green
                }
            }

            // - Logic to set Compressor Status Message ---
            if (data.holdingRegisters) {
                const statusValue = data.holdingRegisters[16];
                switch (statusValue) {
                    case 0: setCompressorStatus('Idle'); break;
                    case 1: setCompressorStatus('Starting Soon'); break;
                    case 2: setCompressorStatus('Running'); break;
                    case 3: setCompressorStatus('Faulted'); break;
                    case 4: setCompressorStatus('Running w/Alarm'); break;
                    default: setCompressorStatus('Unknown'); break;
                }
            }

            // Update charts
            setCharts(prevCharts => {
                const currentTime = new Date();
                return prevCharts.map(chart => {
                    const { selection } = chart;
                    const newValue = selection.type === 'coil'
                        ? (data.coils ? data.coils[selection.address] : 0)
                        : (data.holdingRegisters ? data.holdingRegisters[selection.address] : 0);
                    const newDataPoint = { x: currentTime, y: newValue || 0 };
                    const currentData = chart.data.datasets[0].data || [];
                      const updatedData = [...currentData, newDataPoint].slice(-MAX_DATA_POINTS);
                    return { ...chart, data: { datasets: [{ ...chart.data.datasets[0], data: updatedData }] } };
                });
            });

        } catch (error) {
            // --- THIS IS THE FIX ---
            // A temporary polling error should only display a message and not redirect the user.
            // The next successful poll will clear this error automatically.
            setError(`Failed to fetch latest data: ${error.message}. Retrying...`);
            // The redirect has been removed.
            // setTimeout(() => { window.location.href = HOMEPAGE_URL; }, 3000);
        }
    }, [getAuthHeaders, MAX_DATA_POINTS, alarmConfig]);

    useEffect(() => {
        const initializeDashboard = async () => {
            const headers = getAuthHeaders();
            if (!headers) {
                setTimeout(initializeDashboard, 250);
                return;
            }
            const savedSelections = await loadChartSettings();
            const selectionsToUse = savedSelections || aiConfig.slice(0, 6);
            const initialCharts = selectionsToUse.map((selection, index) => ({
                selection: selection,
                data: createInitialChartState(selection.label, chartColors[index], selection.type === 'coil')
            }));
            setCharts(initialCharts);
            const initialDataPromises = initialCharts.map(chart => fetchInitialChartData(chart.selection));
            const allInitialData = await Promise.all(initialDataPromises);
            setCharts(prevCharts => {
                const updatedCharts = prevCharts.map((chart, index) => ({
                    ...chart,
                    data: { datasets: [{ ...chart.data.datasets[0], data: allInitialData[index] }] }
                }));
                setIsInitialLoad(false);
                return updatedCharts;
            });
        };
       // This is the critical change to prevent the loop ---
        // This logic ensures the initialization function is only called ONCE.
        if (isLoggedIn && isInitialLoad) {
            initializeDashboard();
        }
    }, [isLoggedIn, isInitialLoad, getAuthHeaders, loadChartSettings, fetchInitialChartData, chartColors, aiConfig]);
    


    useEffect(() => {
        if (isInitialLoad || !isLoggedIn) return;
        fetchData(); // Initial fetch
        const interval = setInterval(fetchData, POLLING_INTERVAL);
        return () => clearInterval(interval);
    }, [fetchData, isInitialLoad, isLoggedIn]);


    const handleLogin = async (e) => {
        e.preventDefault();
        setLoginError('');
        try {
            // Updated login call to use the public gateway ---
            const response = await fetch(`${API_GATEWAY_URL}/api/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, password }),
            });
            const data = await response.json();
            if (response.ok && data.token) {
                localStorage.setItem('jwt_token', data.token);
                const decodedToken = jwtDecode(data.token);
                setUserRoles(decodedToken.roles || []);
                setIsLoggedIn(true);
            } else {
                throw new Error(data.message || 'Login failed.');
            }
        } catch (error) {
            setLoginError(error.message);
        }
    };
    
     const handleLogout = () => {
        localStorage.removeItem('jwt_token');
        setIsLoggedIn(false);
        setUsername('');
        setPassword('');
        setLoginError('');
        setUserRoles([]);
        // Redirect to homepage on logout to ensure a clean state
        window.location.href = HOMEPAGE_URL;
    };


    const handleChartSelectionChange = useCallback(async (chartIndex, newSelectionValue) => {
        const newSelection = JSON.parse(newSelectionValue);
        setCharts(prevCharts => {
            const newCharts = [...prevCharts];
            const isCoil = newSelection.type === 'coil';
            const color = newCharts[chartIndex].data.datasets[0].borderColor;
            newCharts[chartIndex] = {
                selection: newSelection,
                data: createInitialChartState(newSelection.label, color, isCoil)
            };
            return newCharts;
        });
        const historicalData = await fetchInitialChartData(newSelection);
        setCharts(prevCharts => {
            const newCharts = [...prevCharts];
            if (newCharts[chartIndex].selection.label === newSelection.label) {
                newCharts[chartIndex].data.datasets[0].data = historicalData;
            }
            return newCharts;
        });
    }, [fetchInitialChartData]);

    // --- MODIFIED: handleWrite now shows a banner instead of alert() ---
    const handleWrite = async (type, address, value) => {
        if (!canWrite()) {
            // Show error banner if not allowed
            setBanner({ show: true, message: 'Access Denied: You do not have permission.', type: 'error' });
            if (bannerTimeoutRef.current) clearTimeout(bannerTimeoutRef.current);
            bannerTimeoutRef.current = setTimeout(() => setBanner({ show: false, message: '', type: 'success' }), 3000);
            return;
        }

        const headers = getAuthHeaders();
        if (!headers) {
             // Show error banner if not authenticated
            setBanner({ show: true, message: 'Not authenticated.', type: 'error' });
            if (bannerTimeoutRef.current) clearTimeout(bannerTimeoutRef.current);
            bannerTimeoutRef.current = setTimeout(() => setBanner({ show: false, message: '', type: 'success' }), 3000);
            return;
        }
        if (value === undefined || value === '') {
             // Show error banner if no value
            setBanner({ show: true, message: 'Please enter a value.', type: 'error' });
            if (bannerTimeoutRef.current) clearTimeout(bannerTimeoutRef.current);
            bannerTimeoutRef.current = setTimeout(() => setBanner({ show: false, message: '', type: 'success' }), 3000);
            return;
        }

        // Clear any previous banner timeout
        if (bannerTimeoutRef.current) clearTimeout(bannerTimeoutRef.current);

        try {
            const response = await fetch(`${API_GATEWAY_URL}/api/write/${DASHBOARD_ID}/${type}`, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({ address, value: Number(value) }),
            });
            const result = await response.json();
            if (!result.success) { throw new Error(result.message || 'Write failed.'); }
            
            // Show SUCCESS banner
            setBanner({ show: true, message: result.message || 'Write successful!', type: 'success' });
            fetchData(); // Refresh data on success

        } catch (err) {
            // Show ERROR banner
            setBanner({ show: true, message: `Error: ${err.message}`, type: 'error' });
        }

        // Set new timeout to hide the banner after 3 seconds
        bannerTimeoutRef.current = setTimeout(() => setBanner({ show: false, message: '', type: 'success' }), 3000);
    };

    const handleHistoryClick = (type, address, name) => setHistoryItem({ type, address, name });
    const handleInputChange = (address, value) => setRegisterInputs(prev => ({ ...prev, [address]: value }));
    const navigateToHomepage = () => window.location.href = HOMEPAGE_URL;


    const chartOptions = () => { // The 'title' argument has been removed
        const now = Date.now();
        const sixHoursAgo = now - (6 * 60 * 60 * 1000);
        return {
            responsive: true, maintainAspectRatio: false, animation: { duration: 0 },
            plugins: {
                legend: { display: false },
                title: { display: false } // This is set to false to hide the default chart title
            },
            scales: {
                x: {
                    type: 'time', min: sixHoursAgo, max: now,
                    time: { tooltipFormat: 'MMM d, h:mm:ss a', displayFormats: { hour: 'h:mm a', minute: 'h:mm a', second: 'h:mm:ss a' } },
                    ticks: { color: '#CCC', source: 'auto' }, grid: { color: 'rgba(255, 255, 255, 0.1)' }
                },
                y: { ticks: { color: '#CCC' }, grid: { color: 'rgba(255, 255, 255, 0.1)' } }
            }
        };
    };

    //  Dynamic class for compressor status box ---
    const compressorStatusClass = `compressor-status-box ${compressorStatus.toLowerCase().replace(/\s+/g, '-')}`;

    const AppStyles = `
        .App { text-align: center; background-color: #1A1A1A; color: #CCCCCC; } /* Dark charcoal background */
        .App-header { background-color: #1A1A1A; min-height: 100vh; display: flex; flex-direction: column; align-items: center; justify-content: flex-start; font-size: calc(10px + 2vmin); color: #CCCCCC; padding: 20px; }
       
        /* MODIFIED: Removed absolute positioning */
        .header-buttons {
            display: flex;
            gap: 10px;
        }
        .home-button, .alarm-button { padding: 10px 15px; border: none; border-radius: 5px; cursor: pointer; font-size: 16px; font-weight: bold; }
        .home-button { background-color: #E4002B; color: white; } /* Red accent for home button */
        .alarm-button { background-color: #666666; color: white; } /* Darker gray for alarm button */
        .error { color: #E4002B; margin: 10px; border: 1px solid #E4002B; padding: 10px; border-radius: 5px; }

        /* MODIFIED: Responsive header container */
        .header-top-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            margin-bottom: 20px;
        }

        /* MODIFIED: Removed absolute positioning */
        .te-branding-box {
            background-color: #2C2C2C;
            border: 1px solid #444444;
            border-radius: 5px;
            padding: 15px 20px;
            font-size: 1.1rem;
            font-weight: bold;
            color: #CCCCCC;
            text-align: center;
        }

        /* MODIFIED: Logo styling */
        .company-logo {
            max-width: 375px;
            height: auto;
        }

        /* Container for the status boxes --- */
        .status-boxes-container {
            width: 95%;
            max-width: 1200px;
            margin: 10px auto 20px;
            display: flex;
            flex-direction: column;
            gap: 10px;
        }

        .alarm-status-box {
            padding: 15px;
            border-radius: 8px;
            color: white;
            text-align: center;
            border: 2px solid;
            box-shadow: 0 4px 12px rgba(0,0,0,0.4);
        }

        .alarm-status-box h3 {
            margin: 0;
            font-size: 1.2rem;
            font-weight: bold;
            text-transform: uppercase;
        }

        /* Styles for Compressor Status Box --- */
        .compressor-status-box {
            padding: 15px;
            border-radius: 8px;
            color: white;
            text-align: center;
            border: 2px solid;
            box-shadow: 0 4px 12px rgba(0,0,0,0.2);
            font-size: 1.2rem;
            font-weight: bold;
            text-transform: uppercase;
        }

        /* --- Colors for different statuses --- */
        .alarm-status-box.ok { background-color: #28a745; border-color: #4CAF50; }
        .alarm-status-box.alarm { background-color: #E4002B; border-color: #FF5252; }

        .compressor-status-box.idle { background-color: #444444; border-color: #666666; }
        .compressor-status-box.starting-soon { background-color: #FFC107; border-color: #FFD54F; }
        .compressor-status-box.running { background-color: #28a745; border-color: #4CAF50; }
        .compressor-status-box.faulted { background-color: #E4002B; border-color: #FF5252; }
        .compressor-status-box.running-w-alarm { background-color: #FF8A00; border-color: #FFB74D; }


        .charts-grid-container { display: grid; grid-template-columns: repeat(auto-fit, minmax(400px, 1fr)); gap: 20px; width: 95%; max-width: 1200px; margin: 20px 0; }
        .chart-wrapper { display: flex; flex-direction: column; background: #2C2C2C; padding: 15px; border-radius: 8px; }
        .chart-container { flex-grow: 1; height: 300px; }
        .chart-selector { margin-bottom: 10px; width: 100%; padding: 5px; background-color: #444444; border: 1px solid #666666; color: #CCCCCC; border-radius: 4px; }
        
        .chart-header { display: flex; justify-content: space-between; align-items: center; margin-top: 10px; margin-bottom: 10px; padding: 0 5px; }
        .chart-title { margin: 0; font-size: 1rem; font-weight: bold; color: #CCCCCC; text-align: left; }
        .chart-live-value { font-size: 1.1rem; font-weight: bold; color: #FFFFFF; background-color: #383838; padding: 4px 10px; border-radius: 5px; border: 1px solid #555555; min-width: 60px; text-align: center; }

        .main-content { display: grid; grid-template-columns: repeat(auto-fit, minmax(400px, 1fr)); justify-content: center; width: 95%; max-width: 1200px; gap: 20px; }
        .section-container { background-color: #2C2C2C; padding: 20px; border-radius: 8px; min-width: 300px; }
        .data-container { display: flex; flex-direction: column; gap: 10px; }
        .data-point { display: grid; grid-template-columns: 1fr auto auto; gap: 10px; align-items: center; padding: 10px; border: 1px solid #444444; border-radius: 5px; background-color: #383838; }
        .data-point.read-only { grid-template-columns: 1fr auto; }
        .data-point strong { cursor: pointer; text-align: left; }
        .coil-on { border-left: 5px solid #28a745; }
        .coil-off { border-left: 5px solid #E4002B; }
        .status-indicator { font-weight: bold; padding: 5px 10px; border-radius: 5px; }
        .coil-on .status-indicator { background-color: #28a745; color: white; }
        .coil-off .status-indicator { background-color: #E4002B; color: white; }
        .write-container { display: flex; gap: 5px; align-items: center; }
        .write-input { width: 80px; padding: 5px; border-radius: 3px; border: 1px solid #666666; background-color: #444444; color: #CCCCCC; }
        .write-button { padding: 5px 10px; cursor: pointer; border-radius: 3px; border: 1px solid #E4002B; background-color: #1A1A1A; color: #E4002B; }
        
        .unit-controls-container { grid-column: 1 / -1; width: 95%; max-width: 1200px; margin: 20px auto; }

        .collapsible-button { display: flex; justify-content: space-between; align-items: center; width: 100%; background: none; border: none; color: #CCCCCC; cursor: pointer; padding: 0 0 15px 0; border-bottom: 1px solid #444444; margin-bottom: 15px; }
        .collapsible-button h2 { margin: 0; font-size: 1.2rem; font-weight: bold; }
        .collapsible-icon { font-size: 1.2rem; transition: transform 0.2s ease-in-out; }
        .collapsible-content { animation: fadeIn 0.4s ease; }
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }

 /* --- START OF FIX: CSS styles for the History Modal --- */
        .modal-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0, 0, 0, 0.75); display: flex; align-items: center; justify-content: center; z-index: 1000; }
        .modal-content { background-color: #2C2C2C; padding: 20px; border-radius: 8px; width: 90%; max-width: 1200px; height: 90vh; display: flex; flex-direction: column; position: relative; }
        .modal-close-button { position: absolute; top: 10px; right: 10px; background: #E4002B; color: white; border: none; border-radius: 50%; width: 30px; height: 30px; font-size: 16px; font-weight: bold; cursor: pointer; display: flex; align-items: center; justify-content: center; }
        .chart-container-modal { flex-grow: 1; height: 50%; }
        .history-controls { display: flex; flex-wrap: wrap; gap: 10px; margin-bottom: 15px; align-items: center; }
        .history-controls label { display: flex; align-items: center; gap: 5px; font-size: 14px; }
        .history-controls input, .history-controls button { background-color: #444; border: 1px solid #666; color: #FFF; padding: 5px 10px; border-radius: 4px; }
        .history-table-container { margin-top: 20px; overflow-y: auto; max-height: 35%; }
        .history-table { width: 100%; border-collapse: collapse; }
        .history-table th, .history-table td { border: 1px solid #444; padding: 8px; text-align: left; }
        .history-table th { background-color: #383838; }
        /* --- END OF FIX --- */


       /* --- VFD--- */
        .vfd-page-container { 
            position: fixed; 
            top: 0; 
            left: 0; 
            width: 100vw; 
            height: 100vh; 
            z-index: 1000; 
            background-color: #1A1A1A;
            display: flex;
            flex-direction: column;
        }
        .vfd-header { display: flex; justify-content: space-between; align-items: center; padding: 15px 20px; background-color: #2C2C2C; color: #CCCCCC; flex-shrink: 0; }
        .vfd-header h2 { margin: 0; font-size: 1.5rem; }
        .vfd-iframe { flex-grow: 1; border: none; width: 100%; }
        /* --- VFD --- */



        /* --- NEW: Styles for the Write Confirmation Banner --- */
        .write-banner {
            position: fixed;
            top: 20px;
            left: 50%;
            transform: translateX(-50%);
            padding: 12px 24px;
            border-radius: 8px;
            color: white;
            font-weight: bold;
            z-index: 2000;
            box-shadow: 0 4px 12px rgba(0,0,0,0.4);
            font-size: 1.1rem;
            transition: all 0.3s ease;
        }
        .write-banner.success {
            background-color: #28a745; /* Green */
            border: 2px solid #4CAF50;
        }
        .write-banner.error {
            background-color: #E4002B; /* Red */
            border: 2px solid #FF5252;
        }
        /* --- END NEW Banner Styles --- */




        /* NEW: Media Query for responsive header */
        @media (max-width: 768px) {
            .header-top-row {
                flex-direction: column;
                gap: 20px;
                align-items: center;
            }

            .te-branding-box {
                order: 2; /* Move branding box below logo on mobile */
            }

            .company-logo {
                max-width: 80%; /* Allow logo to take more width on mobile */
                order: 1; /* Move logo above branding box */
            }
            
            .header-buttons {
                position: static; /* Remove absolute positioning */
                width: 100%;
                margin-top: 20px;
                justify-content: center;
            }

            h1 {
                margin-top: 20px;
            }
            
            .home-button, .alarm-button {
                flex-grow: 1; /* Make buttons take equal space */
            }
        }
    `;


    // --- Restructured render logic ---
    const token = localStorage.getItem('jwt_token');
    const vfdUrlWithToken = token ? `${VFD_URL}?token=${token}` : VFD_URL;

    // ---(if not logged in) ---
    if (!isLoggedIn) {
        return (
            <>
                <style>{AppStyles}</style>
                <div className="login-container">
                    <div className="login-box">
                        <h1 className="login-title">User Login</h1>
                        <p className="login-description">Access the Thomas Evolution Portal</p>
                        <form onSubmit={handleLogin} className="login-form">
                            <div className="input-group">
                                <label htmlFor="username">Username:</label>
                                <input type="text" id="username" value={username} onChange={(e) => setUsername(e.target.value)} required className="login-input" />
                            </div>
                            <div className="input-group">
                                <label htmlFor="password">Password:</label>
                                <input type="password" id="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="login-input" />
                            </div>
                            {loginError && <p className="error-message">{loginError}</p>}
                            <button type="submit" className="login-button">Login</button>
                        </form>
                    </div>
                </div>
            </>
        );
    }

    // --- ALARM PAGE RENDER ---
    if (currentPage === 'alarms') {
        return <AlarmPage setCurrentPage={setCurrentPage} />;
    }
    
    if (currentPage === 'vfd') {
        return (
            <>
                <style>{AppStyles}</style>
                <VFDPage setCurrentPage={setCurrentPage} vfdUrlWithToken={vfdUrlWithToken} />
            </>
        );
    }
    //const alarmStatusClass = alarmStatusMessage.startsWith('🚨') ? 'alarm' : 'ok';

      return (
        <>
            <style>{AppStyles}</style>
            
            <div className="App"> {/* Moved banner inside App for correct styling context */}
                {/* --- NEW: Render the banner here --- */}
                {banner.show && (
                    <div className={`write-banner ${banner.type}`}>
                        {banner.message}
                    </div>
                )}
            
                {historyItem && <HistoryModal item={historyItem} onClose={() => setHistoryItem(null)} backendUrl={`${API_GATEWAY_URL}/api/history/${DASHBOARD_ID}`} getAuthHeaders={getAuthHeaders} />}
                <header className="App-header">


                    {/* Wrapped branding and logo in new container */}
                    <div className="header-top-row">
                        <div className="te-branding-box">AXIOM LINK built and managed By<br/>Thomas Evolution LLC</div>
                        <img src={AccelLogo} alt="Accel Compression Inc. Logo" className="company-logo" /> {/* <--- ADD THIS LINE */}
                    </div>







                    <h1>SHTU 425 Dashboard from Accel Compression      ..Click On Names For History..</h1>
                    <div className="header-buttons">







                        
                        <button onClick={() => setCurrentPage('alarms')} className="alarm-button">ALARM PAGE</button>
                        <button onClick={() => setCurrentPage('vfd')} className="vfd-button">VFD CONTROLS</button>
                        <button onClick={navigateToHomepage} className="home-button">Back to Homepage</button>
                    </div>
                    {error && <p className="error">{error}</p>}
                    {/* ---  Container for both status boxes --- */}
                    <div className="status-boxes-container">
                        {/* --- 4. USE THE NEW STATE VARIABLE HERE --- */}
                        <div className={`alarm-status-box ${alarmStatusType}`}>
                            <h3>{alarmStatusMessage}</h3>
                        </div>
                        <div className={compressorStatusClass}>
                            {compressorStatus}
                        </div>
                    </div>
                    <div className="charts-grid-container">
                        {charts.map((chart, index) => {
                            // Logic to find the current value for this chart
                            const { type, address, label } = chart.selection;
                            let currentValue = '---'; // Default value if data isn't available yet
                            // Define registers that should not have decimals
                            const INTEGER_REGISTERS = [13, 16, 151, 80];
                            if (type === 'coil' && plcData.coils && plcData.coils[address] !== undefined) {
                                currentValue = plcData.coils[address] ? 'ON' : 'OFF';
                            } else if (type === 'register' && plcData.holdingRegisters && plcData.holdingRegisters[address] !== undefined) {
                                const value = plcData.holdingRegisters[address];
                                // Format the value, avoiding decimals for specific integer registers
                                currentValue = INTEGER_REGISTERS.includes(address) ? value : value.toFixed(1);
                            }

                            return (
                                <div key={index} className="chart-wrapper">
                                    <select className="chart-selector" value={JSON.stringify(chart.selection)} onChange={(e) => handleChartSelectionChange(index, e.target.value)}>
                                        <optgroup label="Analog Inputs">{aiConfig.map(p => <option key={`${p.type}-${p.address}`} value={JSON.stringify(p)}>{p.label}</option>)}</optgroup>
                                        <optgroup label="Analog Outputs">{aoConfig.map(p => <option key={`${p.type}-${p.address}`} value={JSON.stringify(p)}>{p.label}</option>)}</optgroup>
                                        <optgroup label="Digital Inputs">{diConfig.map(p => <option key={`${p.type}-${p.address}`} value={JSON.stringify(p)}>{p.label}</option>)}</optgroup>
                                        <optgroup label="Digital Outputs">{doConfig.map(p => <option key={`${p.type}-${p.address}`} value={JSON.stringify(p)}>{p.label}</option>)}</optgroup>
                                    </select>

                                    {/* custom header for the title and live value */}
                                    <div className="chart-header">
                                        <h3 className="chart-title">{label}</h3>
                                        <span className="chart-live-value">{currentValue}</span>
                                    </div>

                                    <div className='chart-container'>
                                        <Line options={chartOptions()} data={chart.data} />
                                    </div>
                                </div>
                            );
                        })}
                    </div> 
                    <div className="unit-controls-container">
                         <CollapsibleSection title="Unit Controls">
                             <div className="data-container">
                                 {/* --- THIS LOGIC IS UPDATED --- */}
                                	{unitControlsConfig.map(({ label, address, isReadOnly, onLabel, offLabel, onClass, offClass }) => {
                                 	const value = plcData.coils ? plcData.coils[address] : false;
                                    
                                    // Determine the text to display
                                    const onText = onLabel || 'ON'; // Default to ON
                                    const offText = offLabel || 'OFF'; // Default to OFF
                                    const statusText = value ? onText : offText;

                                    // Determine the class to use for color
                                    const statusClass = value ? (onClass || 'coil-on') : (offClass || 'coil-off');

                                  	return (
                                      	<div key={`control-${address}`} className={`data-point ${statusClass}`}>
                                          	<strong onClick={() => handleHistoryClick('coil', address, label)}>{label}</strong>
                                          	<div className="status-indicator">{statusText}</div>
                                    	{!isReadOnly && canWrite() && (
                                            	<button className="write-button" onClick={() => handleWrite('coil', address, value ? 0 : 1)}>Toggle</button>
                                      	)}
                                  	</div>
                              	);
                            	})}
                     	</div>
                      	</CollapsibleSection>
                         
                    </div>

                    <div className="main-content">
                        <CollapsibleSection title="Live Digital Inputs (DI)">
                             <div className="data-container">
                                 {diConfig.map(({ label, address }) => {
                                     const value = plcData.coils ? plcData.coils[address] : false;
                                     return (
                                         <div key={`di-${address}`} className={`data-point read-only coil-${value ? 'on' : 'off'}`}>
                                             <strong onClick={() => handleHistoryClick('coil', address, label)}>{label}</strong>
                                             <div className="status-indicator">{value ? 'ON' : 'OFF'}</div>
                                         </div>
                                     );
                                 })}
                             </div>
                        </CollapsibleSection>
                        
                        <CollapsibleSection title="Live Digital Outputs (DO)">
                             <div className="data-container">
                                 {doConfig.map(({ label, address, isReadOnly }) => {
                                     const value = plcData.coils ? plcData.coils[address] : false;
                                     return (
                                         <div key={`do-${address}`} className={`data-point coil-${value ? 'on' : 'off'}`}>
                                             <strong onClick={() => handleHistoryClick('coil', address, label)}>{label}</strong>
                                             <div className="status-indicator">{value ? 'ON' : 'OFF'}</div>
                                             {!isReadOnly && canWrite() && (
                                                 <button className="write-button" onClick={() => handleWrite('coil', address, value ? 0 : 1)}>Toggle</button>
                                             )}
                                         </div>
                                     );
                                 })}
                             </div>
                        </CollapsibleSection>


                        <div className="section-container">
                            <h2>Live Analog Inputs (AI)</h2>
                            <div className="data-container">
                                {aiConfig.map(({ label, address }) => {
                                    const value = plcData.holdingRegisters ? plcData.holdingRegisters[address] : 0;
                                    return (
                                        <div key={`ai-${address}`} className={`data-point read-only hr-value`}>
                                            <strong onClick={() => handleHistoryClick('register', address, label)}>{label}</strong>
                                            <div className="register-value-display">Current: {value}</div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        <div className="section-container">
                            <h2>Live Analog Outputs (AO)</h2>
                            <div className="data-container">
                                {aoConfig.map(({ label, address, isReadOnly }) => {
                                    const value = plcData.holdingRegisters ? plcData.holdingRegisters[address] : 0;
                                    return (
                                        <div key={`ao-${address}`} className={`data-point hr-value`}>
                                            <strong onClick={() => handleHistoryClick('register', address, label)}>{label}</strong>
                                            <div className="register-value-display">Current: {value}</div>
                                            {!isReadOnly && canWrite() && (
                                                <div className="write-container">
                                                    <input type="number" className="write-input" placeholder="New Value" value={registerInputs[address] || ''} onChange={(e) => handleInputChange(address, e.target.value)} />
                                                    <button className="write-button" onClick={() => handleWrite('register', address, registerInputs[address])}>Set</button>
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </header>
            </div>
        </>
    );
}

export default App;
